module.exports = __webpack_public_path__ + "static/raybanden-de34eef5a3d47125f81ba7e45a61f306.jpg";